export { IMusic } from './music.interface';
export { MusicCoreModule } from './music-core.module';
export { MusicCoreService } from './music-core.service';
